export default __webpack_public_path__ + "static/media/bg_5.9c8c9f85.png";